import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Animacao } from '../../core/tools/animacao';
import { ToastrService } from 'ngx-toastr';

/* Services */

import { VendedorService } from '../../core/services/vendedores/vendedor.service';
import { MasterScopeService } from '../../core/services/master-scope/master-scope.service';
import { MasterScopeItem } from '../../core/models/master-scope/master-scope-item';
import { SellerPermissaoEspecialService } from '../../core/services/usuarios/seller-permissao-especial.service';
import { GRUPOS_PERMISSAO, GrupoPermissao, PermissaoDef, permissoesDoGrupo } from '../../core/permissoes/permissoes';

/* Models */

import { Vendedor } from '../../core/models/vendedores/vendedor';
import { CarteiraVinculadaService, CarteiraVinculadaItem } from '../../core/services/vendedores/carteira-vinculada.service';

@Component({
    selector: 'app-vendedores-cadastro',
    templateUrl: './vendedores-cadastro.component.html',
    styleUrls: ['./vendedores-cadastro.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class VendedoresCadastroComponent implements OnInit {
  abaAtiva: 'dados' | 'carteiras' = 'dados';
  carteiras: CarteiraVinculadaItem[] = [];
  carteiraVersao = '';
  carteirasCarregadas = false;
  carteirasCarregando = false;
  carteirasSalvando = false;
  carteirasAlteradas = false;
  carteiraErro = '';
  carteiraBusca = '';
  carteiraBuscando = false;
  carteiraBuscou = false;
  carteiraOpcoes: CarteiraVinculadaItem[] = [];
  carteiraSelecionada = 0;
  carteiraVerTodos = false;

  get vendedorExterno(): boolean {
    const v = this.vendedor;
    return !!v && !v.is_manager && !v.is_master && !v.is_master_seller && !v.is_diretor && !v.is_financeiro;
  }

  get podeGerenciarCarteiras(): boolean {
    const v = this.vendedor;
    return this.flag_gerencia_permissoes && !!v && !v.is_manager && !v.is_master &&
      !v.is_master_seller && !v.is_diretor && !v.is_financeiro;
  }

  abrirAba(aba: 'dados' | 'carteiras') {
    if (aba === 'carteiras' && !this.podeGerenciarCarteiras) return;
    this.abaAtiva = aba;
    if (aba === 'carteiras' && !this.carteirasCarregadas && !this.carteirasCarregando) this.carregarCarteiras();
  }

  carregarCarteiras() {
    if (!this.podeGerenciarCarteiras || this.carteirasCarregando || this.carteirasSalvando) return;
    if (this.carteirasAlteradas && !window.confirm('Recarregar descartará as alterações não salvas da carteira. Continuar?')) return;
    this.carteirasCarregando = true;
    this.carteiraErro = '';
    this.carteiraService.listar(this.vendedor.id).subscribe({
      next: dados => {
        this.carteiras = dados.vinculos;
        this.carteiraVersao = dados.versao;
        this.carteirasCarregadas = true;
        this.carteirasAlteradas = false;
        this.carteirasCarregando = false;
        this.carteiraOpcoes = [];
        this.carteiraSelecionada = 0;
        this.carteiraBuscou = false;
      },
      error: erro => { this.carteiraErro = this.mensagemCarteira(erro); this.carteirasCarregando = false; }
    });
  }

  buscarCarteiras() {
    if (!this.podeGerenciarCarteiras || this.carteiraBuscando || this.carteirasSalvando) return;
    this.carteiraBuscando = true;
    this.carteiraErro = '';
    this.carteiraSelecionada = 0;
    this.carteiraService.buscar(this.vendedor.id, this.carteiraBusca.trim()).subscribe({
      next: itens => {
        this.carteiraOpcoes = itens.filter(i => !this.carteiras.some(v => v.seller_vinculado === i.seller_vinculado));
        this.carteiraBuscou = true;
        this.carteiraBuscando = false;
      },
      error: erro => { this.carteiraErro = this.mensagemCarteira(erro); this.carteiraBuscando = false; }
    });
  }

  adicionarCarteira() {
    if (!this.podeGerenciarCarteiras || this.carteirasSalvando) return;
    const item = this.carteiraOpcoes.find(v => v.seller_vinculado === this.carteiraSelecionada);
    if (!item || item.seller_vinculado === this.vendedor.id || this.carteiras.some(v => v.seller_vinculado === item.seller_vinculado)) return;
    this.carteiras = [...this.carteiras, { ...item, ver_todos: this.carteiraVerTodos }];
    this.carteiraOpcoes = this.carteiraOpcoes.filter(v => v.seller_vinculado !== item.seller_vinculado);
    this.carteiraSelecionada = 0;
    this.carteiraVerTodos = false;
    this.carteirasAlteradas = true;
  }

  removerCarteira(item: CarteiraVinculadaItem) {
    if (!this.podeGerenciarCarteiras || this.carteirasSalvando) return;
    this.carteiras = this.carteiras.filter(v => v !== item);
    this.carteirasAlteradas = true;
  }

  salvarCarteiras() {
    if (!this.podeGerenciarCarteiras || !this.carteirasCarregadas || this.carteirasSalvando || !this.carteirasAlteradas) return;
    this.carteirasSalvando = true;
    this.carteiraErro = '';
    this.carteiraService.salvar(this.vendedor.id, { versao: this.carteiraVersao, vinculos: this.carteiras }).subscribe({
      next: dados => {
        this.carteiras = dados.vinculos;
        this.carteiraVersao = dados.versao;
        this.carteirasAlteradas = false;
        this.carteirasSalvando = false;
        this.toastr.success('', 'Carteiras vinculadas salvas com sucesso!');
      },
      error: erro => { this.carteiraErro = this.mensagemCarteira(erro); this.carteirasSalvando = false; }
    });
  }

  private mensagemCarteira(erro: any): string {
    return erro?.error?.mensagem || 'Não foi possível concluir a operação. Suas alterações foram mantidas para tentar novamente.';
  }
  /* Carregamento */

  carregando: boolean = false;

  /* Dados */

    /* Gerente */

    gerentes: Vendedor[] = [];

    gerenteSelecionado: Vendedor = null;

    /* Telemarketing */

    telemarketings: Vendedor[] = [];

    telemarketingInvalido: boolean = false;

    telemarketingSelecionado: Vendedor = null;

    /* Vendedor(a) */

    vendedor: Vendedor = null;

    vendedorAtivo: boolean = true;

    /* Licença */

    flag_gerencia_permissoes: boolean = (localStorage.getItem('flag_gerencia_permissoes') == 'true');

    licencaAtivaSelecionada: boolean = true;

  /* Permissões Especiais */

  permissoesBloqueadas: string[] = [];
  permissoesCarregadas: boolean = false;
  nivelAprovacao: string = '';

  get gruposPermissao(): GrupoPermissao[] {
    return GRUPOS_PERMISSAO;
  }

  permissoesDoGrupo(grupo: GrupoPermissao): PermissaoDef[] {
    return permissoesDoGrupo(grupo);
  }

  definirGrupo(grupo: GrupoPermissao, bloquear: boolean) {
    const chaves = permissoesDoGrupo(grupo).map(p => p.chave);
    const outras = this.permissoesBloqueadas.filter(c => !chaves.includes(c));
    this.permissoesBloqueadas = bloquear ? [...outras, ...chaves] : outras;
  }

  estaBloqueado(chave: string): boolean {
    return this.permissoesBloqueadas.includes(chave);
  }

  alternarPermissao(chave: string, bloqueado: boolean) {
    if (bloqueado) {
      if (!this.permissoesBloqueadas.includes(chave)) {
        this.permissoesBloqueadas.push(chave);
      }
    } else {
      this.permissoesBloqueadas = this.permissoesBloqueadas.filter(p => p !== chave);
    }
  }

  /* Master Scope */

  masterScope: MasterScopeItem[] = [];
  masterScopeSearch: MasterScopeItem[] = [];
  masterScopeBusca: string = '';
  masterScopeSalvando: boolean = false;

  /* Formulário */

  formDados: UntypedFormGroup;

  enviado: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private vendedorService: VendedorService,
    private masterScopeService: MasterScopeService,
    private sellerPermissaoService: SellerPermissaoEspecialService,
    private carteiraService: CarteiraVinculadaService
  ) { }

  ngOnInit() {
    this.formDados = this.formBuilder.group({
      nome: ["", Validators.required],
      email: ["", Validators.required],
      documento: ["", Validators.required],
      codigo_regiao: [""],
      codigo_vendedor: [""],
      foto_checkout_obrigatorio: [false],
      permite_check_in_distante: [true],
      flag_tira_foto_odometro: [true]
    });

    this.carregarDados();
  }

  get f() {
    return this.formDados.controls;
  }

  /* Dados */

  addUpdate() {
    let retorno = new Promise<void>((resolver) => {
      let vendedor = new Vendedor();

      vendedor.fullname = String(this.formDados.controls["nome"].value).toUpperCase();
      vendedor.email = String(this.formDados.controls["email"].value).toLowerCase();
      vendedor.is_active = this.vendedorAtivo;

      if (this.flag_gerencia_permissoes) {
        vendedor.flag_login_autorizado = this.licencaAtivaSelecionada;
      }

      if (this.gerenteSelecionado != null) {
        vendedor.manager_id = this.gerenteSelecionado.id;
      }

      vendedor.seller_document = this.formDados.controls["documento"].value;
      vendedor.codigo_no_erp_do_cliente = this.formDados.controls["codigo_regiao"].value;
      vendedor.senha_no_erp_do_cliente = this.formDados.controls["codigo_vendedor"].value;

      if (this.telemarketingSelecionado != null) {
        vendedor.nome_equipe = this.telemarketingSelecionado.fullname;
        vendedor.seller_id_tmk = this.telemarketingSelecionado.id;
      }

      if (this.vendedor != null) {
        /* Alterando */

        vendedor.id = this.vendedor.id;
        if (this.vendedorExterno) {
          vendedor.foto_checkout_obrigatorio = this.f.foto_checkout_obrigatorio.value;
          vendedor.check_in_distante = !this.f.permite_check_in_distante.value;
          vendedor.flag_tira_foto_odometro = this.f.flag_tira_foto_odometro.value;
        }
        vendedor.aprovacao_pedido_nivel = this.nivelAprovacao || null;

        let alterarVendedor: boolean = false;

        this.vendedorService.update(vendedor).subscribe(
          alterarVendedores => alterarVendedor = alterarVendedores,
          error => { console.log("Erro: " + error) },
          () => {
            if (alterarVendedor) {
              this.toastr.success("", "Vendedor(a) salvo(a) com sucesso!");

              if (localStorage.getItem('flag_gerencia_permissoes') === 'true') {
                this.sellerPermissaoService.salvar(this.vendedor.id, this.permissoesBloqueadas).subscribe();
              }
            }

            return resolver();
          }
        );
      } else {
        /* Adicionando */

        return resolver();
      }
    });

    return retorno;
  }

  carregarDados() {
    this.carregando = true;

    /* Gerentes */

    this.vendedorService.getMasterManagerByGuidClienteNapis().subscribe(
      gerentes => this.gerentes = gerentes,
      error => { console.log("Erro: " + error) },
      () => {
        if (this.gerentes.length > 0) {
          this.gerenteSelecionado = this.gerentes[0];
        }

        /* Telemarketings */

        this.vendedorService.getMasterSellerByGuidClienteNapis().subscribe(
          telemarketings => this.telemarketings = telemarketings,
          error => { console.log("Erro: " + error) },
          () => {
            if (this.telemarketings.length > 0) {
              this.telemarketingSelecionado = this.telemarketings[0];
            }

            this.verificarAdicionandoAlterando();
          }
        );
      }
    );
  }

  prepararReceberDados(id: number) {
    let retorno = new Promise<void>((resolver) => {
      this.vendedorService.getVendedorById(id).subscribe(
        vendedor => this.vendedor = vendedor,
        error => { console.log("Erro: " + error) },
        () => {
          if (this.vendedor != null) {
            this.formDados.controls["nome"].setValue(this.vendedor.fullname);
            this.formDados.controls["email"].setValue(this.vendedor.email);
            this.formDados.controls["documento"].setValue(this.vendedor.seller_document);
            this.formDados.controls["codigo_regiao"].setValue(this.vendedor.codigo_no_erp_do_cliente);
            this.formDados.controls["codigo_vendedor"].setValue(this.vendedor.senha_no_erp_do_cliente);

            /* Gerente */

            this.gerenteSelecionado = this.gerentes.find(gerentes => gerentes.id == this.vendedor.manager_id);

            /* Telemarketing */

            this.telemarketingSelecionado = this.telemarketings.find(telemarketings => telemarketings.id == this.vendedor.seller_id_tmk);

            this.formDados.patchValue({
              foto_checkout_obrigatorio: this.vendedor.foto_checkout_obrigatorio ?? false,
              permite_check_in_distante: !(this.vendedor.check_in_distante ?? false),
              flag_tira_foto_odometro: this.vendedor.flag_tira_foto_odometro ?? true
            });
            this.vendedorAtivo = this.vendedor.is_active;
            this.nivelAprovacao = this.vendedor.aprovacao_pedido_nivel || '';
            this.licencaAtivaSelecionada = this.vendedor.flag_login_autorizado !== false;

            if (localStorage.getItem('flag_gerencia_permissoes') === 'true') {
              this.sellerPermissaoService.getByVendedor(this.vendedor.id).subscribe(
                bloqueadas => this.permissoesBloqueadas = bloqueadas,
                error => {
                  console.log("Erro: " + error);
                  this.permissoesCarregadas = true;
                },
                () => this.permissoesCarregadas = true
              );
            }

            if (this.vendedor.is_master) {
              this.carregarVinculos();
            }

            return resolver();
          } else {
            this.toastr.error("", "Vendedor(a) inválido(a)!");

            this.router.navigate(["/vendedores/"]);
          }
        }
      );
    });

    return retorno;
  }

  salvar() {
    this.enviado = true;

    if (this.formDados.invalid) {
      return;
    }

    const addUpdate = this.addUpdate();

    addUpdate.then(() => {
      this.router.navigate(["/vendedores/"]);
    });
  }

  verificarAdicionandoAlterando() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    }

    let id: string = null;

    this.route.params.subscribe(params => { id = params.id; });

    if (id != null && !isNaN(parseInt(id)) && isFinite(parseInt(id))) {
      /* Alterando */

      const prepararReceberDados = this.prepararReceberDados(parseInt(id));

      prepararReceberDados.then(() => {
        this.carregando = false;
      });
    } else {
      /* Adicionando */

      this.carregando = false;

      this.router.navigate(["/vendedores/"]);
    }
  }

  /* Gerente */

  selecionarGerente(id_gerente: string) {
    this.gerenteSelecionado = this.gerentes.find(gerentes => gerentes.id == parseInt(id_gerente));
  }

  /* Telemarketing */

  selecionarTelemarketing(id_telemarketing: string) {
    this.telemarketingSelecionado = this.telemarketings.find(telemarketings => telemarketings.id == parseInt(id_telemarketing));
  }

  /* Vendedor(a) */

  selecionarAtivo(ativo: string) {
    this.vendedorAtivo = ativo == "0" ? false : true;
  }

  selecionarLicencaAtiva(valor: string) {
    this.licencaAtivaSelecionada = valor == "0" ? false : true;
  }

  /* Master Scope */

  carregarVinculos() {
    this.masterScopeService.getSellersByMaster(this.vendedor.id).subscribe(
      items => this.masterScope = items,
      error => { console.log('Erro: ' + error); }
    );
  }

  buscarSellers() {
    if (this.masterScopeBusca.length < 2) {
      this.masterScopeSearch = [];
      return;
    }

    this.masterScopeService.searchSellers(this.masterScopeBusca).subscribe(
      items => {
        this.masterScopeSearch = items.filter(s => !this.masterScope.some(m => m.id === s.id));
      },
      error => { console.log('Erro: ' + error); }
    );
  }

  adicionarSeller(seller: MasterScopeItem) {
    if (!this.masterScope.some(m => m.id === seller.id)) {
      this.masterScope = [...this.masterScope, seller];
    }
    this.masterScopeSearch = [];
    this.masterScopeBusca = '';
  }

  removerSeller(id: number) {
    this.masterScope = this.masterScope.filter(s => s.id !== id);
  }

  salvarVinculos() {
    this.masterScopeSalvando = true;
    const ids = this.masterScope.map(s => s.id);

    this.masterScopeService.syncSellers(this.vendedor.id, ids).subscribe(
      ok => {
        if (ok) {
          this.toastr.success('', 'Vínculos salvos com sucesso!');
        } else {
          this.toastr.error('', 'Erro ao salvar vínculos');
        }
      },
      error => { console.log('Erro: ' + error); },
      () => { this.masterScopeSalvando = false; }
    );
  }
}
